import React from 'react';

export class RenderErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error) {
    console.error('[cst_admin_tools] react render failure', error);
  }

  render() {
    if (this.state.error) {
      return (
        <div className="cat-react-state cat-react-state--error">
          {this.props.message || 'React render failed.'}
        </div>
      );
    }

    return this.props.children;
  }
}
